module.exports = __webpack_public_path__ + "static/media/delete_icon.7d499325.svg";